/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CopySimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 255.99316 255.99316"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M215.99365,31.99414H71.98682a8,8,0,1,0,0,16H207.99365v136.001a8,8,0,0,0,16,0V39.99414A8.00008,8.00008,0,0,0,215.99365,31.99414Z" />
        <Rect x={31.98682} y={63.99512} width={160.00586} height={160} rx={8} />
      </G>
    </Svg>
  );
}

export default CopySimple;
